import { QuoteStatus, QuoteStatuses } from '../types/quote-status.type';

export const QUOTE_STATUS_LABELS: Record<QuoteStatus, string> = {
  [QuoteStatuses.DRAFT]: 'Brouillon',
  [QuoteStatuses.READY]: 'Prêt',
  [QuoteStatuses.SENT]: 'Envoyé',
  [QuoteStatuses.ACCEPTED]: 'Accepté',
  [QuoteStatuses.REFUSED]: 'Refusé',
  [QuoteStatuses.EXPIRED]: 'Expiré',
  [QuoteStatuses.CANCELLED]: 'Annulé',
};
